import { graphql } from "gatsby";
import React from "react";
import useWindowWidth from "../../../hooks/useWindowWidth";
import { Colours } from "../../../utils/colours";
import WrappedSection from "../../WrappedSection/WrappedSection";
import { MissionStatementBlockFlat } from "./Flat/MissionStatementBlockFlat";
import { MissionStatementBlockSquare } from "./Square/MissionStatementBlockSquare";

export interface ParagraphMissionStatementProps {
	heading: string;
	subheading?: string;
	description?: string;
	maskOption: string;
	backgroundTheme: DogsTrust.ThemeColors;
	buttonText?: string;
	buttonUrl?: string;
	imgSrc: string;
	imgAlt: string;
	jumpLinksTitle?: string;
}

export const getParagraphMissionStatementProps = ({
	field_heading,
	field_jump_links_title,
	field_sub_heading,
	field_ms_description,
	field_image_mask_option,
	field_background_colour_option,
	field_link,
	relationships: {
		field_featured_image: { field_media_image },
	},
}: Queries.ParagraphMissionStatementDataFragment): ParagraphMissionStatementProps => ({
	heading: field_heading,
	subheading: field_sub_heading,
	description: field_ms_description?.value,
	maskOption: field_image_mask_option,
	backgroundTheme: field_background_colour_option as DogsTrust.ThemeColors,
	buttonText: field_link?.title,
	buttonUrl: field_link?.uri,
	imgSrc: field_media_image.uri,
	imgAlt: field_media_image.alt,
	jumpLinksTitle: field_jump_links_title,
});

export const ParagraphMissionStatement: React.FC<
	ParagraphMissionStatementProps
> = ({ ...props }) => {
	const screenWidth = useWindowWidth();

	// We set this here as this is a paragraph rather than a section
	// So we need to check here instead of at the PageManager level
	const isHomePage =
		typeof window !== "undefined" ? window.location.pathname === "/" : false;

	const getBgColour = (theme: DogsTrust.ThemeColors) => {
		const themeColors = {
			yellow: Colours.SUNSHINE_YELLOW,
			white: Colours.WHITE,
			oatmeal: Colours.OATMEAL,
		};
		return themeColors[theme];
	};

	return (
		<WrappedSection
			sectionName="ParagraphMissionStatement"
			isHomePage={isHomePage}
			sectionColour={getBgColour(props.backgroundTheme)}
		>
			{screenWidth < 768 ? (
				<MissionStatementBlockSquare {...props} />
			) : (
				<MissionStatementBlockFlat {...props} />
			)}
		</WrappedSection>
	);
};

export const fragment = graphql`
    fragment ParagraphMissionStatementData on paragraph__mission_statement {
        __typename
        id
        field_heading
		field_jump_links_title
        field_sub_heading
        field_ms_description {
			value
		}
        field_image_mask_option
        field_background_colour_option
        field_link {
            title
            uri
        }
        relationships {
            field_featured_image {
                ...MediaImageData
            }
        }
    }
`;
